<template lang="pug">
    v-container( fluid class="py-0" )
        v-card( :ripple='false' :href="'https://sugar.xprt.com/#Opportunities/' + opportunity.id"  elevation=0 outlined class=" tw-p-2"  target="blank")
            v-row(no-gutters pa-0 ma-0 class="grey lighten-4 tw--m-2 tw-p-2")
                v-col(class="tw-font-semibold blue--text text--darken-3 ")
                    |{{ opportunity.name }}
                v-col(class="text-right")
                    v-chip(small class="blue--text text--lighten-5 tw-text-base tw-font-semibold" color="blue darken-3") {{ opportunity.sales_stage }}
            v-row(no-gutters class="grey lighten-4 tw--m-2 tw-p-2 tw-pt-1 tw-pb-3")
                v-col(class="grey--text text--darken-1 tw-font-semibold tw-text-sm")
                    |{{ opportunity.assigned_user_name }}
                v-col(class="grey--text text--darken-1 tw-font-semibold tw-text-sm text-right mr-1")
                    div(v-if="opportunity.amount > 0") {{ amount }}
            v-row(no-gutters class="tw-bg-white" class="white tw--m-2 tw-p-2 tw-pt-1 tw-pb-0")
                v-col(class="tw-border-r")
                    div(class="grey--text text--darken-1 tw-text-xs ") Created
                    div(class=" grey--text text--darken-1 tw-text-sm tw--mt-1 tw-font-medium") {{ this.$moment(opportunity.date_entered).format('MMM Do, YYYY') }} 
                v-col(class=" tw-ml-2")
                    div(class="grey--text text--darken-1 tw-text-xs") Expected to close
                    div(class=" grey--text text--darken-1 tw-text-sm tw--mt-1 tw-font-medium") {{ this.$moment(opportunity.date_closed).format('MMM Do, YYYY') }}
        
</template>
<script>
export default {
    props:{
         opportunity: {
             type: Object,
             default: () => {}
         }
    },
    data() {
        return {
           
        }

    },
    computed:{
        amount: function(){
            return new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'EUR'
            }).format(this.opportunity.amount);
        }
    },
    methods: {
        openOpportunity(){
            console.log('test')
        }
    },
}
</script>